/**
 * Footer Menu - Expandable submenus
 */

// Add toggle arrows to parent menu items
const parentMenuItems = document.querySelectorAll(
	'.footer-menu-1 .menu-item-has-children > a, .footer-menu-2 .menu-item-has-children > a'
);

parentMenuItems.forEach((link) => {
	const toggleSpan = document.createElement('span');
	toggleSpan.className = 'submenu-toggle';
	link.appendChild(toggleSpan);
});

// Handle click to expand/collapse
document.addEventListener('click', (e) => {
	const link = e.target.closest('.footer-menu-1 .menu-item-has-children > a, .footer-menu-2 .menu-item-has-children > a');

	if (!link) return;

	e.preventDefault();
	e.stopPropagation();

	const menuItem = link.parentElement;
	menuItem.classList.toggle('is-open');
});

